import { Directive, Input, Optional, ElementRef, OnChanges, Renderer2 } from '@angular/core';
import { RouterLink, RouterLinkWithHref } from '@angular/router';


@Directive({
    selector: '[routerLink][disabled]'
})
export class RouterLinkDisabledDirective implements OnChanges {
    @Input('disabled') public isDisabled: boolean = false;

    constructor(
        @Optional() routerLink: RouterLink,
        @Optional() routerLinkWithHref: RouterLinkWithHref,
        public elementRef: ElementRef,
        public renderer: Renderer2
    ) {
        const link = routerLink ?? routerLinkWithHref;
        const onClick = link.onClick;

        link.onClick = (...args: unknown[]): boolean => {
            if (this.isDisabled) {
                return !routerLinkWithHref;
            }

            return onClick.apply(link, args);
        };
    }

    ngOnChanges() {
        // TODO: check if `isDisabled` was changed
        this.renderer.setAttribute(this.elementRef.nativeElement, 'disabled', this.isDisabled.toString());
    }
}